import { useSelector } from 'react-redux';
import { ReduxState } from 'src/redux/redux-state';
import { useGetClientDetailsQuery } from 'src/redux/organization/organization.endpoints';
import { ClientView } from 'src/redux/organization/organization.types';

interface UseLiveClientViewsOptions {
  previewClientId?: string | null;
  clientId?: string | null;
}

/**
 * Fetches the current client's view configuration from the API on each mount,
 * falling back to the login-time Redux snapshot while the query is loading.
 */
export function useLiveClientViews(options: UseLiveClientViewsOptions = {}) {
  const userState = useSelector((state: ReduxState) => state.userState);
  const effectiveClientId =
    options.previewClientId ??
    options.clientId ??
    userState.activeClient?.ext_client_id ??
    '';

  const { data: liveClient } = useGetClientDetailsQuery(effectiveClientId, {
    skip: !effectiveClientId,
    refetchOnMountOrArgChange: true,
  });

  const clientViews: ClientView[] | undefined =
    liveClient?.views ?? userState.activeClient?.views;

  return {
    clientViews,
    liveClient,
    effectiveClientId,
  };
}
